import { useState } from "react";
import { GlyphStyleToggle } from "@-/dev.improve.haniverse.routes.nav.app.learn._components.glyph-style-toggle";
import { LessonPageContainer } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._components.container";
import { LessonPageGlyphBlock } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._components.glyph-block";
import {
  LessonPageHeaderTexts,
  useLessonPageLevelSurfaceTexts,
} from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._components.header-texts";
import { LessonLevelSurface } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._components.lesson-level-surface";
import { NewMorphemeLessonLayoutContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._context";
import { useNewMorphemeLessonRevealPressMutation } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._lib.reveal";
import { NavContext } from "@-/dev.improve.haniverse.routes.nav._context";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { View } from "@-/com.npmjs.react-native";

export function LessonPageLandscapeView({ isActive = true }: { isActive?: boolean }) {
  const [replayKey, setReplayKey] = useState(0);
  const replayStrokes = () => setReplayKey((key) => key + 1);
  const [grapheme, lesson, lessonCharacters] = useContextSelectors(
    NewMorphemeLessonLayoutContext,
    (c) => c.grapheme,
    (c) => c.lesson,
    (c) => c.lessonCharacters,
  );
  const levelSurfaceTexts = useLessonPageLevelSurfaceTexts();
  const revealMutation = useNewMorphemeLessonRevealPressMutation();
  const [displayMode, toggleDisplayMode] = useContextSelectors(
    NavContext,
    (c) => c.characterDisplayMode,
    (c) => c.toggleCharacterDisplayMode,
  );

  return (
    <LessonPageContainer
      headerEnd={
        <GlyphStyleToggle
          className="shrink-0"
          displayMode={displayMode}
          onPress={toggleDisplayMode}
        />
      }
      isActive={isActive}
      onReplayPress={displayMode === "svg" ? replayStrokes : undefined}
      revealMutation={revealMutation}
    >
      {/* The glyph fills the space above the bottom-aligned curriculum strip. */}
      <View className="min-h-0 flex-1 flex-col gap-2.25 px-2.25 pb-2.25">
        <View className="min-h-0 flex-1">
          <LessonPageHeaderTexts variant="landscape" />
          <LessonPageGlyphBlock isActive={isActive} replayKey={replayKey} />
        </View>
        <View className="shrink-0">
          <LessonLevelSurface
            activeMorpheme={grapheme}
            characters={lessonCharacters}
            description={levelSurfaceTexts.description}
            label={levelSurfaceTexts.label}
            level={lesson}
          />
        </View>
      </View>
    </LessonPageContainer>
  );
}
